import React from 'react'

function ChatSubmitMessage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <g>
            <g>
              <path
                stroke="#000"
                strokeWidth="2"
                d="M18.776 1.225l-6.847 17.334-3.333-7.177L1.444 8.07l17.332-6.845z"
                transform="translate(-1282.000000, -674.000000) translate(1274.000000, 666.000000) translate(8.000000, 8.000000)"
              />
              <path
                fill="#000"
                d="M12.573 -0.313L13.906 -0.313 13.906 13.687 12.573 13.687z"
                transform="translate(-1282.000000, -674.000000) translate(1274.000000, 666.000000) translate(8.000000, 8.000000) translate(13.239767, 6.687482) rotate(-315.000000) translate(-13.239767, -6.687482)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ChatSubmitMessage
